<template>
  <b-row class="py-2">
    <b-col
      :cols="6"
      class="pb-3"
    >
      <BaseMatchDate :date="startDate" />
    </b-col>
    <b-col
      :cols="6"
      class="d-flex justify-content-end pb-3"
    >
      <BaseBadge :variant="matchBadgeVariant">
        {{ $t(`match.status.${status}`) }}
      </BaseBadge>
    </b-col>

    <b-col
      :cols="5"
      class="d-flex flex-column align-items-center text-center"
    >
      <b-img
        :src="team1.image_url"
        fluid
        :class="$style.teamImage"
      />
      <span :class="$style.teamNameText">
        {{ team1.display_name[$i18n.locale] || team1.display_name['en'] }}
      </span>
    </b-col>

    <b-col
      :cols="2"
      class="d-flex align-items-center justify-content-center"
    >
      <BaseBadge
        v-if="[matchStatuses.live, matchStatuses.finished].includes(status)"
        :variant="status === matchStatuses.finished ? 'light-gray' : 'green'"
      >
        <span>{{ scoreTeam1 || 0 }}</span>
        <span class="px-2">|</span>
        <span>{{ scoreTeam2 || 0 }}</span>
      </BaseBadge>
    </b-col>

    <b-col
      :cols="5"
      class="d-flex flex-column align-items-center text-center"
    >
      <b-img
        :src="team2.image_url"
        fluid
        :class="$style.teamImage"
      />
      <span :class="$style.teamNameText">
        {{ team2.display_name[$i18n.locale] || team2.display_name['en'] }}
      </span>
    </b-col>
  </b-row>
</template>

<script>
import { MATCH_STATUSES } from '@/store/modules/matches/matchDetail'
import { getMatchBatchClass } from '@/helpers/ui'
import BaseBadge from '@/components/Atoms/BaseBadge'
import BaseMatchDate from '@/components/Atoms/BaseMatchDate'
export default {
  name: 'TheMatchHeader',
  components: {
    BaseMatchDate,
    BaseBadge,
  },
  props: {
    startDate: {
      type: Date,
      default: new Date(),
      required: true,
    },
    status: {
      type: String,
      required: true,
      default: null,
    },
    team1: {
      type: Object,
      required: true,
      default: () => {},
    },
    team2: {
      type: Object,
      required: true,
      default: () => {},
    },
    scoreTeam1: {
      type: Number,
      required: false,
      default: 0,
    },
    scoreTeam2: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      matchStatuses: MATCH_STATUSES,
    }
  },
  computed: {
    matchBadgeVariant() {
      return getMatchBatchClass(this.status)
    },
  },
}
</script>

<style lang="scss" module>
  @import "../../assets/scss/variables";
  .teamImage {
    max-height: 75px;
  }

  .teamNameText {
    font-weight: 600;
    margin-top: .5rem;
    display: flex;
    flex: 1;
    align-items: center;
  }
</style>
